import { emitEvent } from "./emit-event";
import {
  EVENT_TYPE,
  FORM_ACTION,
  FormInteractionEventParameters,
  FormType
} from "./events";
import { getMetaContent } from "./utilities";

window.$$epiforms?.(document).ready(() => {
  window.$$epiforms?.(".EPiServerForms").on("formsSubmitted", (event: Event) => {
    const form = event.currentTarget as HTMLFormElement;

    if (form && "isFinalizedSubmission" in event && event.isFinalizedSubmission) {
      const formId = form.id;
      const formName = form.dataset.formTitle;
      const formType = form.dataset.formType;

      const block = form.closest<HTMLElement>("[data-block-id]");
      const contentTypeElement = form.closest<HTMLElement>("[data-content-type]");

      if (formType) {
        emitEvent(
          EVENT_TYPE.formInteraction,
          {
            content_id: block?.dataset.blockId,
            content_type:
              block?.dataset.blockType ??
              contentTypeElement?.dataset.contentType ??
              "content",
            form_action: FORM_ACTION.submit,
            form_id: formId,
            form_name: formName,
            form_type: formType as FormType,
            campaign_name: getMetaContent("campaign-name")
          } satisfies FormInteractionEventParameters,
          true
        );
      }
    }
  });
});
